export default __webpack_public_path__ + "static/media/immaginelore2.0cdc86f4.png";